<script>
    export let race;
    export let canDelete = false;
    export let onDelete;

    async function handleDelete() {
        if (confirm('Are you sure you want to delete this race? This action cannot be undone.')) {
            await onDelete(race.id);
        }
    }
</script>
<style>
  .card {
    position: relative;
    min-height: 200px;
  }

  .card-content {
    padding-bottom: 3rem;
    position: relative;
  }

  .action-buttons {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
    display: flex;
    gap: 0.5rem;
    align-items: center;
    height: 36px;
  }

  .action-btn {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    cursor: pointer;
    border: none;
    color: white;
    padding: 0;
    line-height: 1;
  }

  .download-btn {
    background-color: #1976D2;
    margin-top: 1rem;
  }

  .download-btn:hover {
    background-color: #1565C0;
    transform: translateY(-2px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

  .delete-btn {
    background-color: #f44336;
  }

  .delete-btn:hover {
    background-color: #d32f2f;
    transform: translateY(-2px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

  .action-btn i {
    font-size: 1.2rem;
  }

  .tooltip {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 0.5rem;
    border-radius: 4px;
    font-size: 0.8rem;
    white-space: nowrap;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: 1000;
  }

  .action-btn:hover .tooltip {
    opacity: 1;
  }

  .podium {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    gap: 10px;
    margin: 20px 0;
  }
  .podium-place {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    border-radius: 5px 5px 0 0;
    min-width: 80px;
  }
  .first {
    background-color: #FFD700;
    height: 120px;
  }
  .second {
    background-color: #C0C0C0;
    height: 100px;
  }
  .third {
    background-color: #CD7F32;
    height: 80px;
  }
  .position {
    font-weight: bold;
    margin-bottom: 5px;
  }
  .boat-info {
    color: #333;
    font-size: 0.9em;
  }

  .race-title a {
    font-size: 1.5em;
    color: #1976D2;
    text-decoration: none;
    transition: color 0.3s ease;
  }
  .race-title a:hover {
    color: #1565C0;
  }

  .download-section {
    text-align: center;
    margin-top: 20px;
  }
  .download-btn {
    background-color: #1976D2 !important;
    transition: background-color 0.3s ease !important;
  }
  .download-btn:hover {
    background-color: #1565C0 !important;
  }

  .delete-btn {
    background-color: #f44336 !important;
    color: white !important;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 1rem;
    transition: all 0.3s ease;
  }

  .delete-btn:hover {
    background-color: #d32f2f !important;
    transform: translateY(-2px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

  .delete-btn i {
    font-size: 1.2rem;
  }
</style>

<div class="card">            
    <div class="card-content">
      <div class="race-title">
        <a href='results/race?raceId={race.id}'>{race.seriesName} Race {race.raceNumber}</a>
      </div>
      
      <div class="podium">
        <div class="podium-place second">
          <div class="position">2nd</div>
          <div class="boat-info">{race.second}</div>
        </div>
        <div class="podium-place first">
          <div class="position">1st</div>
          <div class="boat-info">{race.first}</div>
        </div>
        <div class="podium-place third">
          <div class="position">3rd</div>
          <div class="boat-info">{race.third}</div>
        </div>
      </div>

      <div class="metadata">
        <p><i class="material-icons tiny">flag</i> Race type: {race.raceType}</p>
        <p><i class="material-icons tiny">schedule</i> Completed: {race.completedDt.toLocaleString('en-UK')}</p>
      </div>

      <div class="action-buttons">
        <a class="action-btn download-btn" href="https://europe-west1-sail-score.cloudfunctions.net/getResults?raceId={race.id}" title="Download Results">
          <i class="material-icons">cloud_download</i>
          <span class="tooltip">Download Results</span>
        </a>
        {#if canDelete}
          <button class="action-btn delete-btn" on:click={handleDelete} title="Remove from Cloud">
            <i class="material-icons">delete</i>
            <span class="tooltip">Remove from Cloud</span>
          </button>
        {/if}
      </div>
    </div>
</div>